import React, { useState, Fragment } from 'react';
import { Observer } from 'mobx-react';
import {
  Button,
  Dialog,
  DialogTitle,
  Typography,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { toJS } from 'mobx';
import { Link } from 'react-router-dom';
import OpenInNew from '@material-ui/icons/OpenInNew';
import { useRootStore } from '../../../stores/BridgeProvider';
import ColoredButton from '../../util/ColoredButton';
import { safeEval } from '../../util/UtilFunctions';

const InvoiceDeal = ({ deal, reinitialize }) => {
  const { dataStore, dealMapperStore } = useRootStore();
  const [confirm, setConfirm] = useState(false);

  const handleClose = () => {
    setConfirm(false);
    // WIPE DEALMAPPER
    setTimeout(() => dealMapperStore.clearState(), 300);
  };

  const handleOpen = () => {
    setConfirm(true);
  };

  const { DealId } = deal;

  const realInvoiceDeal = async () => {
    const loadInfo = async () => {
      await dealMapperStore.loadData({ dealIds: [DealId] });

      return dealMapperStore.reset();
    };
    await loadInfo();
    dealMapperStore.voucherDeals();
    handleOpen();
  };

  // Get Changes

  const saveMapping = async () => {
    try {
      await dealMapperStore.persistState();
      dataStore.refreshDataAfterDealMap();
      reinitialize();
      handleClose();
    } catch (e) {
      //
    }
  };
  // Save

  const mappingContent = () => {
    const vouchArray = dealMapperStore.vouchers.map((vouch, i) => {
      // console.log(toJS(vouch));
      const vts = dealMapperStore.getVoucherTransactionsOnVoucher(vouch);
      // console.log(toJS(vts[0]));
      const vouchContact =
        vouch.ContactName ||
        safeEval(() => dataStore.getContactFromId(vouch.ContactId).Name, null);
      return (
        <div>
          <h4 style={{ marginBottom: '1rem' }}>
            {vouch.VoucherNumber} - {vouchContact}
          </h4>
          {vts.map((vt, j) => (
            <div style={{ marginBottom: '7px' }}>
              {j + 1}). Price: ${vt.Price} | Quantity:{' '}
              {parseInt(vt.Quantity, 10)}
            </div>
          ))}
        </div>
      );
    });
    return <div>{vouchArray.map(item => item)}</div>;
  };

  const hasChanges = dealMapperStore.isAnythingPending;

  return (
    <Observer
      render={() => {
        return (
          <Fragment>
            <ColoredButton
              style={{ marginRight: '10px' }}
              onClick={realInvoiceDeal}
              color="#01A1E8"
            >
              Invoice Now
            </ColoredButton>

            <Dialog open={confirm} onClose={handleClose} maxWidth="md">
              <div
                style={{
                  padding: '15px 15px 0px 15px',
                  minWidth: '330px',
                }}
              >
                <Typography variant="h4">Review Invoices</Typography>

                <DialogContent>
                  {hasChanges
                    ? mappingContent()
                    : 'This deal is already fully invoiced! Only deals with "Unmapped" Receivables and Payables are in need of invoicing.'}
                  {hasChanges && (
                    <Link
                      style={{
                        fontSize: '0.8rem',
                        color: '#01A1E8',
                        display: 'block',
                        marginTop: '1rem',
                      }}
                      to={{
                        pathname: '/deal-mapper',
                        state: { dealIds: [DealId], invoiceDeal: true },
                      }}
                    >
                      Show detail in mapper
                    </Link>
                  )}
                </DialogContent>

                <DialogActions>
                  <Button onClick={handleClose} color="secondary">
                    Cancel
                  </Button>
                  {hasChanges && (
                    <Button onClick={saveMapping} color="primary">
                      Save Invoices
                    </Button>
                  )}
                </DialogActions>
              </div>
            </Dialog>
          </Fragment>
        );
      }}
    />
  );
};

export default InvoiceDeal;

// PENDING VOUCHER
// AccountId: '06ed222e-512e-11ec-8dc6-163dc8d12e9f';
// ContactId: '070fba8b-512e-11ec-8dc6-163dc8d12e9f';
// Description: 'Test';
// DueDate: '2021-12-02';
// IsEditable: true;
// Pending: true;
// StatusId: 1;
// VoucherDate: '2021-12-23';
// VoucherId: 'tmp-9cfc94e1-6421-11ec-be97-d7bd940eca1f';
// VoucherNumber: 'Test-2';
// VoucherTypeId: 1;

// PENDING VOUCHER TRAN
// AccountId: '06ed23d4-512e-11ec-8dc6-163dc8d12e9f';
// CategoryId: '0bac9b4e-512e-11ec-8dc6-163dc8d12e9f';
// Description: '3';
// Pending: true;
// Price: 909;
// Quantity: '1.0000';
// VoucherId: 'tmp-9cfc94e1-6421-11ec-be97-d7bd940eca1f';
// VoucherTranId: 'tmp-9cfc94e2-6421-11ec-be97-d7bd940eca1f';
